import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  background: (p) => p.palette.common.white,
  padding: (p) => p.spacing(1),
  gap: (p) => p.spacing(2),
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[400],
  borderRadius: (p) => p.spacing(1),
};

export const box: SxStyleFunc<boolean | undefined> = (isDefault) => ({
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: isDefault
    ? (p) => p.palette.success[500]
    : (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1.5),
  background: isDefault
    ? (p) => p.palette.success[50]
    : (p) => p.palette.common.white,
});
